import { HttpContextToken } from '@angular/common/http';

export const IS_SHOW_LOADER = new HttpContextToken<boolean>(() => true);